import { ISearchable } from './Searchable.itf'

/**
* @typedef  LabelConstructor
* @type {object}
* @property {Object} idLabel - the idLabel value
* @property {string} nom - the nom value
* @property {string} png - the png value
* @property {integer} idEnseigne - the idEnseigne value
* */

export class Label extends ISearchable {
  /**
   * Creates an instance of Label.
   * @memberof Label
   * */
  constructor(object) {
    super()
    this.idLabel = object.idLabel
    this.png = object.png
    this.nom = object.nom
    this.idEnseigne = object.idEnseigne
  }

  formatToDisplay() {
    this.nom = this.nom.charAt(0).toUpperCase() + this.nom.substring(1).toLowerCase()
    this.raccourci = this.nom
    this.lineClassName = 'labelLine'
    this.boxClassName = 'labelBox'
    this.displayType = 'Labels'
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-labelLine'
    return this
  }

  getIdAttribute() {
    return 'idLabel'
  }

  getNameAttribute() {
    return 'nom'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }

  getIdEnseigneAttribute() {
    return 'idEnseigne'
  }
}
